import React, { useEffect } from "react";
import { useAppDispatch } from "_redux/hooks";
import {
  setHasOfflineProducts,
  setOfflineAvailableSellers,
} from "_redux/actions/catalog";
import { useLiveQuery } from "dexie-react-hooks";
import { eFoodDB } from "pwa/db/efood.db";
import usePWADisplayMode from "pwa/displayMode/usePWADisplayMode";
import SimpleOnlineStatusChecker from "./SimpleOnlineStatusChecker";
import DefaultOnlineStatusChecker from "./DefaultOnlineStatusChecker";

const EMPTY_ARRAY: string[] = [];

const OnlineStatusChecker: React.FC<{ cache?: RequestCache }> = ({ cache }) => {
  const dispatch = useAppDispatch();
  const hasOfflineProducts =
    useLiveQuery(() => eFoodDB.products.count(), [], 0) > 0;
  const offlineAvailableSellers = useLiveQuery(
    () =>
      eFoodDB.products
        .orderBy("sellerId")
        .uniqueKeys((s) => s as Array<string>),
    [],
    EMPTY_ARRAY
  );
  const { isBrowser } = usePWADisplayMode();

  useEffect(() => {
    dispatch(setHasOfflineProducts(hasOfflineProducts));
  }, [dispatch, hasOfflineProducts]);

  useEffect(() => {
    dispatch(setOfflineAvailableSellers(offlineAvailableSellers));
  }, [dispatch, offlineAvailableSellers]);

  if (isBrowser) {
    return <SimpleOnlineStatusChecker />;
  }
  return <DefaultOnlineStatusChecker cache={cache} />;
};

export default OnlineStatusChecker;
